import React, { useState, useEffect } from 'react'
import { useStyles } from './style'
import { Grid, Divider, Hidden, Typography, Box, Link, CircularProgress } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { ENROLLED } from './constant'
import CustomDialog from '../../Components/CustomDialog'
import battery from '../../Assets/Images/battery.svg'
import ethernet from '../../Assets/Images/ethernet.svg'
import wifi from '../../Assets/Images/wifi.svg'
import cellsignal from '../../Assets/Images/signal.svg'
import _ from 'lodash'
import { OutlinedButton } from '../../elements'
import { systemsService } from '../../Services/SystemsService/SystemsService'
import * as messageTypes from '../../utils/messageTypes'
import { DisplayMessage } from '../../Components/index'

function SystemCard(props) {
  const classes = useStyles()
  const history = useHistory()
  const [openInfo, setOpenInfo] = useState(false)
  const { deviceInfo, program, siteId, accountId } = props
  const { data } = props
  const enrolled = data && data.application_status === ENROLLED
  const programStandardization = _.get(props, 'program.feature_flags.program_standardization', false)
  const [participationType, setParticipationType] = useState()
  const [loadingParticipationType, setLoadingParticipationType] = useState(false)
  const [messageType, setMessageType] = useState(null)
  const [message, setMessage] = useState(null)
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setParticipationType(data && data.participation_type ? data.participation_type : 'ACTIVE_PASSIVE');
  }, [data && data.participation_type]);

  const getParticipationTypeLabel = (type) => {
    if (type === null || type === 'ACTIVE_PASSIVE') return 'ACTIVE PASSIVE';
    if (type === 'ACTIVE_ONLY') return 'ACTIVE ONLY';
    return type;
  }

  const handleToggleParticipation = async () => {
    if (!program || !program.program_key || !data || !data.enrollment_application_id) {
      return;
    }
    
    setLoadingParticipationType(true);
    const nextType = participationType === 'ACTIVE_ONLY' ? 'ACTIVE_PASSIVE' : 'ACTIVE_ONLY';
    systemsService.updateEnrollmentParticipationType(accountId, siteId, nextType)
      .then(data => {
        setParticipationType(data.participation_type)
        setLoadingParticipationType(false)
      }).catch (error => {
        setLoadingParticipationType(false)
        setMessageType(messageTypes.ERROR)
        setMessage(_.get(error, 'data.error.displayMessage', 'Failed to update Participation Type'))
        setOpen(true)
      }) 
  }

  const connectionMapper = (value) => {
    if (value === true)
      return '(Active)'
    else if (value === false)
      return '(Idle)'
    return '(Not Available)'
  }

  const getDialogContent = () => {
    return (
      <>
        <Box mb={2}>
          <Box className={classes.heading} mb={1}>
            Envoy ({deviceInfo['envoys'].length})
          </Box>
          <Grid container spacing={2}>
            {deviceInfo['envoys'].map(envoy => (
              <Grid item xs={6} sm={4}>
                <Box className={classes.dataContainer} mb={1}>
                  <div className={classes.subHeading}>{envoy.product_name}</div>
                  <div className={classes.content}>SN: {envoy.serial_number}</div>
                  <Box className={classes.content} mb={2}>SKU: {envoy.model_name}</Box>
                  <div className={classes.content}>Last Reported: {envoy.last_report_date}</div>
                  <div className={classes.content}>Firmware: {envoy.fw_version}</div>
                  <Box mt={2} className={classes.subHeading}>Connection Type</Box>
                  <div><img src={ethernet} className={classes.icons} alt="" /><span className={classes.subHeading}> Ethernet </span><span className={classes.content}>{`${envoy.connection_details && connectionMapper(envoy.connection_details.ethernet)} ${envoy.connection_details && envoy.connection_details.ethernet && envoy.reporting_frequency ? `: Reports data every ${Math.floor(envoy.reporting_frequency / 60)} mins` : ''}`}</span></div>
                  <div><img src={wifi} className={classes.icons} alt="" /><span className={classes.subHeading}> Wifi </span><span className={classes.content}>{`${envoy.connection_details && connectionMapper(envoy.connection_details.wifi)} ${envoy.connection_details && envoy.connection_details.wifi && envoy.reporting_frequency ? `: Reports data every ${Math.floor(envoy.reporting_frequency / 60)} mins` : ''}`}</span></div>
                  <div><img src={cellsignal} className={classes.icons} alt="" /><span className={classes.subHeading}> Cell Modem </span><span className={classes.content}>{`${envoy.connection_details && connectionMapper(envoy.connection_details.cellular)} ${envoy.connection_details && envoy.connection_details.cellular && envoy.reporting_frequency ? `: Reports data every ${Math.floor(envoy.reporting_frequency / 60)} mins` : ''}`}</span></div>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box mb={2}>
          <Box className={classes.heading} mb={1}>
            Storage ({deviceInfo['encharges'].length})
          </Box>
          <Box display="flex" flexWrap="wrap">
            <Box position="relative" display="inline-flex" my={2}>
              <CircularProgress
                variant="determinate"
                className={classes.bottomCircle}
                size={70}
                {...props}
                value={100}
              />
              <CircularProgress variant="determinate" classes={{ root: classes.circleRoot }} value={_.get(deviceInfo, 'encharge_info.soc', '') ? deviceInfo.encharge_info.soc.replace('%', '') : ''} size={70} />
              <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
                flexDirection="column"
              >
                <img src={battery} className={classes.batteryIcon} alt="" />
                <Typography variant="caption" style={{ fontWeight: 600 }} component="div" color="textSecondary">{_.get(deviceInfo, 'encharge_info.soc', '')}</Typography>
              </Box>
            </Box>
            <Box position="relative" display="inline-flex" flexDirection="column" p={2} justifyContent="center" >
              <Box className={classes.content}>Available Energy</Box>
              <Box className={classes.content}><span className={classes.subHeading}>{deviceInfo.encharge_info.available_energy}</span> of {deviceInfo.encharge_info.total_energy}</Box>
              <Box className={classes.content}>{`Active Encharge (s): ${!_.isNil(deviceInfo.encharge_info.encharge_count) ? deviceInfo.encharge_info.encharge_count : '-'} of ${!_.isNil(deviceInfo.encharge_info.total_encharge_count) ? deviceInfo.encharge_info.total_encharge_count : '-'}`}</Box>
            </Box>
          </Box>
          <Grid container spacing={2}>
            {deviceInfo['encharges'].map(encharge => (
              <Grid item xs={6} sm={4}>
                <div className={classes.dataContainer}>
                  <div className={classes.subHeading}>{encharge.product_name}</div>
                  <div className={classes.content}>SN: {encharge.serial_number}</div>
                  <div className={classes.content}>SKU: {encharge.model_name}</div>
                  <div className={classes.content}>Firmware: {encharge.fw_version}</div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box mb={2}>
          <Box className={classes.heading} mb={1}>
            Enpower ({deviceInfo['enpowers'].length})
          </Box>
          <Grid container spacing={2}>
            {deviceInfo['enpowers'].map(enpower => (
              <Grid item xs={6} sm={4}>
                <div className={classes.dataContainer}>
                  <div className={classes.subHeading}>{enpower.product_name}</div>
                  <div className={classes.content}>SN: {enpower.serial_number}</div>
                  <div className={classes.content}>SKU: {enpower.model_name}</div>
                  <div className={classes.content}>Firmware: {enpower.fw_version}</div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Box>
        <Box className={classes.heading} mb={1}>
          Microinverters ({deviceInfo && deviceInfo['micros'].length})
        </Box>
        <Grid container spacing={2}>
          {deviceInfo['micros'].map(micro => (
            <Grid item xs={6} sm={4}>
              <div className={classes.dataContainer}>
                <div className={classes.subHeading}>{micro.product_name}</div>
                <div className={classes.content}>SN: {micro.serial_number}</div>
                <div className={classes.content}>SKU: {micro.model_name}</div>
              </div>
            </Grid>
          ))}
        </Grid>
      </>
    )
  }

  return (
    <div className={classes.cardContainer}>
      <CustomDialog open={openInfo} handleClose={() => setOpenInfo(false)} title="Device Info" content={deviceInfo ? getDialogContent() : 'No Information Available'} fullWidth maxWidth="lg" />
      <Grid className={classes.gridContainer} container spacing={4}>
        <Grid item sm={12} md={enrolled ? 4 : 6}>
          <Grid container spacing={2}>
            {programStandardization && data?.formfields?.form_data ?
              data.formfields.form_data.map(field => (
                <>
                  <Grid item xs={6}>
                    <span className={classes.cardText}>{field.fieldName}</span>
                  </Grid>
                  <Grid item xs={6}>
                    <span className={classes.cardValue}>{_.get(field, 'fieldValue', '--')}</span>
                  </Grid>
                </>
              ))
              :
              <>
                <Grid item xs={6}>
                  <span className={classes.cardText}>Full Name</span>
                </Grid>
                <Grid item xs={6}>
                  <span className={classes.cardValue}>{data.formfields ? data.formfields.name : '--'}</span>
                </Grid>
                <Grid item xs={6}>
                  <span className={classes.cardText}>Email</span>
                </Grid>
                <Grid item xs={6}>
                  <span className={classes.cardValue}>{data.formfields ? data.formfields.email_address : '--'}</span>
                </Grid>
                <Grid item xs={6}>
                  <span className={classes.cardText}>Street address</span>
                </Grid>
                <Grid item xs={6}>
                  <span className={classes.cardValue}>{data.formfields ? data.formfields.street_address : '--'}</span>
                </Grid>
                <Grid item xs={6}>
                  <span className={classes.cardText}>Electric account number</span>
                </Grid>
                <Grid item xs={6}>
                  <span className={classes.cardValue}>{data.formfields ? data.formfields.electric_account_number : '--'}</span>
                </Grid>
                <Grid item xs={6}>
                  <span className={classes.cardText}>Zip/Postal Code</span>
                </Grid>
                <Grid item xs={6}>
                  <span className={classes.cardValue}>{data.formfields ? data.formfields.zip : '--'}</span>
                </Grid>
              </>
            }
          </Grid>
        </Grid>
        <Grid item sm={12} md={enrolled ? 4 : 6}>
          <Box display="flex" justifyContent="space-between" flexDirection="column" style={{ height: '100%' }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <span className={classes.cardText}>{`${enrolled ? 'Enrolled' : 'Unenrolled'} Program`}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.cardValue}>{data && data.program_name_admin_ui ? data.program_name_admin_ui : '--'}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.cardText}>Total Energy</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.cardValue}>{data && data.battery_capacity ? data.battery_capacity + ' kWh' : '--'}</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.cardText}>Total Power</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.cardValue}>{data && data.battery_power ? data.battery_power + ' kW' : '--'}</span>
              </Grid>
              {program && program.feature_flags && program.feature_flags.committed_power_in_program &&
                <>
                  <Grid item xs={6}>
                    <span className={classes.cardText}>Committed Power</span>
                  </Grid>
                  <Grid item xs={6}>
                    <span className={classes.cardValue}>{data && data.incentive && data.incentive.committed_power ? data.incentive.committed_power + ' kW' : '--'}</span>
                  </Grid>
                </>
              }
              <Grid item xs={6}>
                <span className={classes.cardText}>Optional ID</span>
              </Grid>
              <Grid item xs={6}>
                <span className={classes.cardValue}>{_.get(data, 'formfields.premise_id', '--')}</span>
              </Grid>
              {program && program.feature_flags && program.feature_flags.battery_reserve_soc_configurability &&
                <>
                  <Grid item xs={6}>
                    <span className={classes.cardText}>VPP Reserve Soc</span>
                  </Grid>
                  <Grid item xs={6}>
                    <span className={classes.cardValue}>{data && data.reserved_soc ? data.reserved_soc : '--'}</span>
                  </Grid>
                </>
              }
              {program && program.family_key && program.family_key === 'CT_ESS' &&
                <>
                  <Grid item xs={6} className={classes.typeWrapper}>
                    <Box className={classes.cardText} >Participation Type</Box>
                  </Grid>
                  <Grid item xs={6} className={classes.dateRange} >
                    <span className={classes.cardValue}>{getParticipationTypeLabel(participationType)}</span>
                    <OutlinedButton
                      classes={classes.buttons}
                      label={loadingParticipationType ? 'Updating...' : 'change'}
                      onClick={handleToggleParticipation}
                      disabled={loadingParticipationType}
                    />
                    <DisplayMessage open={open} message={message} messageType={messageType} handleClose={() => setOpen(false)} />
                  </Grid>
                </>
              }
            </Grid>
            <Box pt={2}>
              <div className={classes.link} onClick={() => setOpenInfo(true)}>{enrolled && 'Device Info'}</div>
            </Box>
          </Box>
        </Grid>
        {enrolled &&
          <>
            <Hidden smDown>
              <Grid item md={1} justify="center">
                <Divider orientation="vertical" flexItem style={{ height: '100%', marginLeft: '50%' }} />
              </Grid>
            </Hidden>
            <Grid item sm={12} md={3}>
              <Box display="flex" justifyContent="space-between" flexDirection="column" style={{ height: '100%' }}>
                <Grid className={classes.tagsContainer} container spacing={2}>
                  <Grid item xs={12}>
                    <span>Tags</span>
                  </Grid>
                  {data.tags && Object.keys(data.tags).map(tag => (
                    tag === 'STATE' || tag === 'CITY' || tag === 'ZIP' ? '' :
                      <>
                        <Grid item xs={6}>
                          <span className={classes.cardText}>{tag}</span>
                        </Grid>
                        <Grid item xs={6}>
                          <span className={classes.cardValue}>{data.tags[tag]}</span>
                        </Grid>
                      </>
                  ))}
                </Grid>
                <Box pt={2}>
                  <div className={classes.link} onClick={() => history.push({ pathname: `/programs/${data.program_id}/tags-manager`, state: { programId: data.program_id } })}>{enrolled && 'Manage Tags'}</div>
                </Box>
              </Box>
            </Grid>
          </>
        }
      </Grid>
    </div >
  )
}

export default SystemCard